<app-progress-loader />

<mat-sidenav-container [hasBackdrop]="true">
  <mat-sidenav class="sliding-sheet" #slidingSheet [fixedInViewport]="true">
    @if (slidingSheetState.config$ | async; as config) {
      @if (!config.hideHeader && config.title) {
        <header class="sliding-sheet-header">
          <h3 class="py-2 px-3 mb-0 d-inline-block">{{ config.title }}</h3>
          <button class="sliding-sheet-close" (click)="slidingSheet.close()">
            <mat-icon>close</mat-icon>
          </button>
        </header>
      }
    }
    <ng-template [sliding-sheet]="slidingSheet"></ng-template>
  </mat-sidenav>
  <mat-sidenav-content class="app-sidenav-content">
    <lib-header *ngIf="authState.isAuthenticated$ | async" (logoutEvent)="handleLogout($event)">
      <div class="d-flex w-100 justify-content-end pe-3 border-end">
        @if (companyState.companySetting.showCreateOrderBtn !== false) {
          <div *showIfPermitted="permission.ORDER_CREATE">
            <a mat-stroked-button color="primary" (click)="createOrder()">
              <mat-icon>list_alt_add</mat-icon>
              Create Order
            </a>
          </div>
        }
      </div>
    </lib-header>

    <!-- All pages rendered here -->
    <main class="body_wrap">
      <router-outlet />
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
@if (showAssist) {
  <appraisal-assistant-agent *ngIf="authState.isAuthenticated$ | async"></appraisal-assistant-agent>
}
